var map = {
	"./modal-attribution-new.hbs": 213,
	"./modal-confirm-copy-content.hbs": 214,
	"./modal-copy-svg-from-search-list-not-premium-user.hbs": 215,
	"./modal-craft-info.hbs": 216,
	"./modal-funnel-premium-add-icon.hbs": 217,
	"./modal-funnel-premium-freePng.hbs": 218,
	"./modal-license.hbs": 219,
	"./modal-palette-not-premium-user.hbs": 220,
	"./modal-premium.hbs": 221,
	"./modal-remove-palette.hbs": 222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;